import { GetQuestionParams } from '@/config/types';
import showError from '@/handler/error';
import { apiTmx } from '../api-config';

const token = sessionStorage.getItem('chave');

export const getQuestionByEvidenceId = (params: GetQuestionParams) => apiTmx
  .get(`/api/quiz/getbyevidence?tokenKey=${params.tokenKey}&cdEvidence=${params.evidenceId}`, {
    headers: { Authorization: token?.toString() },
  })
  .then((response) => response.data)
  .catch(showError);
